import { Component,Inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material';



@Component({
  selector: 'snack-bar-response.component',
  templateUrl: './snack-bar-response.component.html',
  styleUrls: ['./snack-bar-response.component.css'],
  })
  export class SnackBarResponse {
    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }
    
  }